<template>
  <div class="category-features row roomy">
    <div
      v-for="category in categories"
      :key="category.id"
      class="category-feature-lg column-4 laptop:column-2"
    >
      <site-link
        :to="$category({ name: category.id })"
        :class="`card ${color}`"
        :style="`--card-margin-bottom: var(--spacing-2xl); --card-header-background: var(--fa-navy); --card-link-hover-border-color: var(--fa-${color})`"
        @click.native="$posthog.capture('category_landing:suggested_category_link_click', { category: currentCategory, suggested_category: category.label })"
      >
        <div class="header">
          <i
            :class="`fas fa-${category.icon} fa-fw fa-3x padding-y-3xs`"
            :style="`color: var(--fa-${color});`"
          />
        </div>
        <div class="section">
          <p class="text-capitalize text-truncate">{{ category.label }} icons</p>
        </div>
      </site-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CategorySuggestions',

    props: {
      suggestionCount: {
        type: Number
      },
      currentCategory: {
        type: String
      },
      categoryIcons: {
        type: Array
      },
      color: {
        type: String,
        default: 'blue'
      }
    },

    data() {
      return {
        suggestions: this.getRandomCategories()
      }
    },

    computed: {
      categories() {
        return this.suggestions
      }
    },

    watch: {
      currentCategory() {
        this.suggestions = this.getRandomCategories()
      }
    },

    methods: {
      getRandomCategories() {
        const suggestions = []

        for (let index = 0; index < this.suggestionCount; index++) {
          let category = ''
          let count = 0

          do {
            // Find a random category not equal to the current category and not already in the list
            category = this.categoryIcons[Math.floor(Math.random() * this.categoryIcons.length)]
          } while (suggestions.find((c) => c.id == category.id) || this.currentCategory == category.id || count > 20)

          suggestions.push({
            id: category.id,
            label: category.label,
            icon: category.icon
          })
        }

        return suggestions
      }
    }
  }
</script>
